const INITIAL_STATE = {
  usersList: [],
  total: 0,
  current: 1,
  lecturerList: [],
  loading: false,
  loadingLecturerList: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'GET_USERS_LIST_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'GET_USERS_LIST_SUCCESS':
      return {
        ...state,
        usersList: action.payload.users,
        total: action.payload.total,
        loading: false,
      };
    case 'GET_USERS_LIST_FAILURE':
      return {
        ...state,
        loading: false,
      };
    case 'GET_LECTURER_LIST_REQUEST':
      return {
        ...state,
        loadingLecturerList: true,
      };
    case 'GET_LECTURER_LIST_SUCCESS':
      return {
        ...state,
        lecturerList: action.payload,
        loadingLecturerList: false,
      };
    case 'GET_LECTURER_LIST_FAILURE':
      return {
        ...state,
        loadingLecturerList: false,
      };
    case 'CREATE_USER_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'CREATE_USER_SUCCESS':
      return {
        ...state,
        usersList: [...state.usersList, action.payload.data],
        loading: false,
      };
    case 'CREATE_USER_FAILURE':
      return {
        ...state,
        loading: false,
      };
    case 'EDIT_USER_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'EDIT_USER_SUCCESS':
      return {
        ...state,
        usersList: [...state.usersList.filter(user => user.lecturerId !== action.payload.lecturerId), action.payload.data],
        loading: false,
      };
    case 'EDIT_USER_FAILURE':
      return {
        ...state,
        loading: false,
      };
    case 'DELETE_USER_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'DELETE_USER_SUCCESS':
      return {
        ...state,
        usersList: [...state.usersList.filter(user => user.lecturerId !== action.payload.lecturerId)],
        loading: false,
      };
    case 'DELETE_USER_FAILURE':
      return {
        ...state,
        loading: false,
      };
    case 'CHANGE_CURRENT_USER_PAGE':
      return {
        ...state,
        current: action.payload,
      };
    case 'LOGOUT':
      return INITIAL_STATE;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/users.js